import {inject, injectable} from 'inversify';

import {i18n} from '@yourcoach/i18n';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {AssessmentModel} from './Assessment.model';

@injectable()
export class AssessmentFactory
  implements BaseDomainFactory<AssessmentModel, AssessmentModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: AssessmentModel.Props) {
    return this.modelsRegistry.put(new AssessmentModel(props));
  }

  createEmpty() {
    return this.create({
      avatar: null,
      description: '',
      diagram: {points: [], style: AssessmentModel.DiagramStyle.BLUE},
      id: '',
      questions: [],
      showDescriptionToClient: false,
      status: AssessmentModel.Status.ACTIVE,
      timeToFill: '',
      title: i18n.t('shared:assessment_not_found'),
    });
  }
}
